<div class="modal-header">
  <h4 class="modal-title">Missing Resume</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="onNotNow()" ></button>
</div>
<div class="modal-body">
  <p>A resume was not uploaded for this candidate. To help our us better understand the candidate’s/employee’s background, please upload a resume/CV/LinkedIn profile.
    <br>
</p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="onYes()"><span class="fa fa-cloud-upload"></span> Upload Resume</button>
  <button type="button" class="btn btn-default" (click)="onNo()"><span class="fa fa-ban"></span> No Resume Available</button>
  <button type="button" class="btn btn-primary" (click)="onNotNow()"><span class="fa fa-envelope"></span> Not Now – I will email a resume to testing&#64;ccoleadership.com later.</button>
</div>
